module.exports = __webpack_public_path__ + "img/3x.e563820.jpg";